/**
 * https://react.i18next.com/getting-started
 * https://react.i18next.com/legacy-v9/step-by-step-guide
 * https://github.com/i18next/i18next-browser-languageDetector
 */

import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './translations/en';
import th from './translations/th';

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en,
      th,
    },
    // lng: 'th',
    fallbackLng: 'th',
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      wait: false,
      useSuspense: false,
    },
    whitelist: ['en', 'th'],
    detection: {
      // order and from where user language should be detected
      order: ['cookie'],

      // keys or params to lookup language from
      lookupCookie: 'i18next',

      // cache user language on
      caches: ['cookie'],

      // optional expire and domain for set cookie
      cookieMinutes: 10,
    },
  });

export default i18n;
